// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TshSpLzdcAIAjsTSQFWW{gap:8px;font-weight:400}.TshSpLzdcAIAjsTSQFWW>div{align-items:flex-start}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/tags/ui/TagsModalContent/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,OAAA,CACA,eAAA,CAGF,0BACE,sBAAA","sourcesContent":[".name {\n  gap: 8px;\n  font-weight: 400;\n}\n\n.name > div {\n  align-items: flex-start;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"name": `TshSpLzdcAIAjsTSQFWW`
};
export default ___CSS_LOADER_EXPORT___;
